import TSVExport from '../TSVExport'
import makeRenderer from './Table'
import TablePQI from './TablePQI'
import TablePxQ from './TablePxQ'

export default {
  'Table': makeRenderer({ subtotals: true }),
  'Table PxQ': TablePxQ,
  'Table PxQ + Importe': TablePQI,
  'Table Heatmap': makeRenderer({ heatmapMode: 'full', subtotals: true }),
  'Table Col Heatmap': makeRenderer({ heatmapMode: 'col', subtotals: true }),
  'Table Row Heatmap': makeRenderer({ heatmapMode: 'row', subtotals: true }),
  'Exportable TSV': TSVExport,
}
